// Re-export React.lazy
import {lazy} from 'react'
export default lazy
